"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function WhatWeDo() {
  const { t } = useLanguage();

  const cards = [
    {
      icon: "ri-calendar-check-line",
      title: "Annual Tune-Up",
      desc: "Full inspection. Cleaning, lubrication, hardware check.",
    },
    {
      icon: "ri-brush-line",
      title: "Track Cleaning",
      desc: "Sliding door tracks deep-cleaned. Restore smooth glide.",
    },
    {
      icon: "ri-drop-line",
      title: "Hardware Lubrication",
      desc: "Hinges, rollers, locks, cranks. Marine-grade products.",
    },
    {
      icon: "ri-sparkling-line",
      title: "Window Cleaning",
      desc: "Interior and exterior glass. Streak-free results.",
    },
    {
      icon: "ri-layout-grid-line",
      title: "Screen Cleaning",
      desc: "Screens removed, cleaned, rehung. Repair available.",
    },
    {
      icon: "ri-search-line",
      title: "Preventive Inspection",
      desc: "Catch seal failure and water entry points early.",
    },
  ];

  return (
    <section className="bg-white py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-secondary text-center mb-3">
          {t("maint.servicesH2")}
        </h2>
        <p className="text-gray-600 text-center max-w-[720px] mx-auto mb-12 text-base">
          Preventive care that extends window life and prevents costly repairs.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div
              key={c.title}
              className="bg-white rounded-xl border-t-4 border-primary p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary mb-4">
                <i className={`${c.icon} text-xl`} />
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">{c.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}